/**
 * mwApp.common module <br>
 * Contains sidebar, header, common services, etc
 *
 * @namespace mwApp/common
 */

import 'moment'
import 'moment-timezone'

// import AngularChartJS from 'angular-chart.js'
import AngularFilter from 'angular-filter'
import AngularLoadingBar from 'angular-loading-bar'
import AngularMessages from 'angular-messages'
import AngularSmartTable from 'angular-smart-table'
import AngularUiBootstrap from 'angular-ui-bootstrap'
import AngularUiMask from 'angular-ui-mask'
import NgFocusIf from 'ng-focus-if'
import NgQuill from 'ng-quill'
import UiRouter from '@uirouter/angularjs'
import NgSanitize from 'angular-sanitize'
import UiSelect from 'ui-select'
import angularDragula from 'angularjs-dragula'
import 'angular-bootstrap-colorpicker'
import 'angular-drag-and-drop-lists'
import 'angular-ui-scroll'
import 'ng-mask'
import 'st-multi-sort'
import 'ng-tags-input'

import commonConfig from './common.config'

import formCtrlMixinFactory from './mixins/formCtrl.mixin'
import locationCtrlMixinFactory from './mixins/locationCtrl.mixin'
import m2mCtrlMixinFactory from './mixins/m2mCtrl.mixin'
import onOffCtrlMixinFactory from './mixins/onoffCtrl.mixin'
import stopEventCtrlMixinFactory from './mixins/stopEventCtrl.mixin'
import tabsCtrlMixinFactory from './mixins/tabsCtrl.mixin'

import ControllerDecorator from './services/controller.decorator'
import QDecorator from './services/q.decorator'

import StorageSvc from './services/storage.service'
import BreadcrumbsSvc from './services/breadcrumbs.service'
import HistorySvc from './services/history.service'
import NotifySvc from './services/notify.service'
import { AlertLightSvc, AlertSvc, ConfirmDlgCtrl } from './services/alert.service'
import KeycloakConfigCheckSvc from '../../app/helpers/keycloak-config-check'
import * as filters from './services/filters.service'
import * as directives from './common.directives'
import * as stDirectives from './st.directives'
import * as VODDirectives from './vod.directives'
import * as stFilters from './st.filters'
import * as ciDirectives from './directives/contentItems/ci.directives'
import AddTranscoderModalCtrl from './directives/contentItems/addTranscoderModal.controller'

import HeaderCtrl from './header.controller'
import MaintenanceCtrl from './maintenance.controller'
import Error404Ctrl from './404.controller'
import WrapperCtrl from './wrapper.controller'
import openPopupCtrlMixinFactory from './mixins/openPopupCtrl.mixin'
import Error403suCtrl from './403su.controller'
import angular from 'angular'

export default
angular.module('mwApp.common', [
  NgSanitize,
  AngularFilter,
  UiRouter,
  AngularSmartTable,
  AngularMessages,
  AngularUiBootstrap,
  UiSelect,
  'ui.scroll',
  AngularLoadingBar,
  'dndLists',
  // AngularChartJS,
  NgQuill,
  AngularUiMask,
  'ngMask',
  NgFocusIf,
  'colorpicker.module',
  angularDragula(angular),
  'ngTagsInput'
])
  .config(commonConfig)

  .factory('formCtrlMixin', formCtrlMixinFactory)
  .factory('locationCtrlMixin', locationCtrlMixinFactory)
  .factory('m2mCtrlMixin', m2mCtrlMixinFactory)
  .factory('onOffCtrlMixin', onOffCtrlMixinFactory)
  .factory('openPopupCtrlMixin', openPopupCtrlMixinFactory)
  .factory('stopEventCtrlMixin', stopEventCtrlMixinFactory)
  .factory('tabsCtrlMixin', tabsCtrlMixinFactory)

  .decorator('$q', QDecorator)
  .decorator('$controller', ControllerDecorator)

  .service('storageSvc', StorageSvc)
  .service('breadcrumbsSvc', BreadcrumbsSvc)
  .service('historySvc', HistorySvc)
  .service('notifySvc', NotifySvc)
  .service('alertLiteSvc', AlertLightSvc)
  .service('alertSvc', AlertSvc)
  .service('keycloakConfigCheckSvc', KeycloakConfigCheckSvc)
  .controller('ConfirmDlgCtrl', ConfirmDlgCtrl) // controller for alert services

  .filter('entitytype', filters.entitytypeFilter)
  .filter('addOrEdit', filters.addOrEditFilter)
  .filter('groupByOrNot', filters.groupByOrNotFilter)
  .filter('filterBy', filters.filterByFilter)
  .filter('isACLDisable', filters.isACLDisableFilter)
  .filter('mmnt', filters.mmntFilter)
  .filter('highlightSearch', filters.highlightSearchFilter)
  .filter('mask', filters.maskFilter)
  .filter('niceRound', filters.niceRoundFilter)
  .filter('bandwidth', filters.bandwidthFilter)
  .filter('formatRss', filters.formatRssFilter)
  .filter('stLocalFilterTable', stFilters.stLocalFilterTable)

  .directive('ngReallyClick', directives.ngReallyClick)
  .directive('ngReallyChange', directives.ngReallyChange)
  .directive('sidebarMenu', directives.sidebarMenu)
  .directive('fileModel', directives.fileModel)
  .directive('compileTemplate', directives.compileTemplate)
  .directive('applyValidity', directives.applyValidity)
  .directive('dndfile', directives.dndfile)
  .directive('loader', directives.loader)
  .directive('ngOnload', directives.ngOnload)
  .directive('onReadFile', directives.onReadFile)
  .directive('cropper', directives.cropper)
  .directive('dynamicTemplate', directives.dynamicTemplate)
  .directive('scroll', directives.scroll)
  .directive('cost', directives.cost)
  .directive('inputWithDecimals', directives.inputWithDecimals)
  .directive('inputWithCounter', directives.inputWithCounter)
  .directive('highlightEdit', directives.highlightEdit)
  .directive('trackCursorContext', directives.trackCursorContext)
  .directive('cursorContextExtractor', directives.cursorContextExtractor)
  .directive('textareaWithCounter', directives.textareaWithCounter)
  .directive('inputNumber', directives.inputNumber)
  .directive('inputTags', directives.inputTags)
  .directive('imageError', directives.imageError)
  .directive('destroyHandler', directives.destroyHandler)
  .directive('uiSelectOnOpen', directives.uiSelectOnOpen)
  .directive('refreshTable', stDirectives.refreshTable)
  .directive('highlightTable', stDirectives.highlightTable)
  .directive('pageSelect', stDirectives.pageSelect)
  .directive('pageSize', stDirectives.pageSize)
  .directive('stSelectMultiple', stDirectives.stSelectMultiple)
  .directive('stSelect', stDirectives.stSelect)
  .directive('stDates', stDirectives.stDates)
  .directive('stNumbers', stDirectives.stNumbers)
  .directive('stSearchClassBy', stDirectives.stSearchClassBy)
  .directive('stTableFilter', stDirectives.stTableFilter)
  .directive('packageLinks', directives.packageLinks)
  .directive('moviedbToVod', VODDirectives.moviedbToVod)
  .directive('ciStreamPolicy', ciDirectives.ciStreamPolicy)
  .directive('ciStreamPolicyRule', ciDirectives.ciStreamPolicyRule)
  .directive('ciDrmProfiles', ciDirectives.ciDrmProfiles)
  .directive('ciAssignedContentSets', ciDirectives.ciAssignedContentSets)
  .directive('ciAcl', ciDirectives.ciAcl)

  .controller('HeaderCtrl', HeaderCtrl)
  .controller('MaintenanceCtrl', MaintenanceCtrl)
  .controller('WrapperCtrl', WrapperCtrl)
  .controller('Error404Ctrl', Error404Ctrl)
  .controller('Error403suCtrl', Error403suCtrl)
  .controller('AddTranscoderModalCtrl', AddTranscoderModalCtrl)
